import { useEffect, useRef, useState } from "react";
import "../assets/scss/custom/typeahead-component.scss";
import { useLocation } from "react-router-dom";

export interface DataListType {
  key: string;
  value: string;
}

export interface TypeHeadBase {
  key: string;
  value: string;
  info1?: string| null;
  info2?: string| null;
  info3?: string| null;
  infoDate?: Date |null;
}


interface AsyncTypeahead {
  options: string[] | DataListType[];
  callback: (payload: any) => void;
  onSelect?: (payload: any) => void;
  callbackOnEmpty?:() => void;
  defaultValue?: any;
  placeholder?: string;
  name?: string;
  required?: boolean;
  isValid?: boolean;
  disabled?: boolean;
  addClass?: string;
  resetInput?: boolean;
  unsetId?: () => void;
  searchError?: string;
  filterAfterOneLetter?: boolean
}

const AsyncTypeahead = (props: AsyncTypeahead) => {
  const [query, setQuery] = useState<any>("");
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [noData, setNoData] = useState<boolean>(false)
  const [defaultValue, setDefaultValue] = useState<string | null>(props.defaultValue);
  const containerRef = useRef<any>(null);
  const location = useLocation();

  const fetchOptionList = (search: string) => {
    setDefaultValue(null)
    props.callback(search);
  };
  useEffect(() => {
    setSuggestions(props.options);
    setIsLoading(false);
    if(query?.length > 2 && props.options.length == 0) {
      setNoData(true);
    } else {
      setNoData(false);
    }
  }, [props.options]);
  useEffect(() => {
    if (!props.options.length) setQuery("");
  }, [props.isValid]);
  useEffect(() => {
    setQuery("");
    setSuggestions([]);
    setNoData(false);
  }, [location]);

  useEffect(() => {
    setQuery("");
    setSuggestions([]);
  }, [props.resetInput])

  const handleClearInput = () => {
    if (props.onSelect) {
      props.onSelect(null);
    }
  }
  const handleInputChange = (e: any) => {
    if(!e.target.value) {
      setNoData(false);
      setSuggestions([]);
    }
    setQuery(e.target.value);
    if (e.target.value.length > 2 && !props.filterAfterOneLetter) {
      setIsLoading(true);
      fetchOptionList(e.target.value);
    }else if (e.target.value.length && props.filterAfterOneLetter){
      setIsLoading(true);
      fetchOptionList(e.target.value);
    }
     else if(props.callbackOnEmpty){
      props.callbackOnEmpty();
    } else {
      setSuggestions([]);
      handleClearInput();
    }
  };

  const handleSuggestionClick = (suggestion: any) => {
    if (props.onSelect) {
      props.onSelect(suggestion);
    }
    setQuery(suggestion.value ? suggestion.value : suggestion);
    if(props.resetInput){
      setQuery('');
    }
    setSuggestions([]);
  };
  const getHighlightedText = (text: string, highlight: string) => {
    if (!text && !highlight) {
      return text;
    }
    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = text.split(new RegExp(`(${escapedHighlight})`, "gi"));
    return parts.map((part, i) =>
      part && highlight && part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={i} className="highlight-selected">
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  useEffect(() => {
    // setQuery(props.defaultValue);
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        // if (!query) {
        //   handleClearInput();
        // }
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(()=>{
    setDefaultValue(props.defaultValue);

  },[props.defaultValue])

  return (
    <div className="typeahead-container search-box d-flex" ref={containerRef}>
      <span className={`material-symbols-outlined search-box__icon ${props.addClass ? 'top-1' : ''}`}>
        search
      </span>
      <input
        type="text"
        autoComplete="off"
        name={props.name}
        className={`form-control search-box__input fw-normal fs-12 ${props.addClass ? props.addClass : ''}`}
        value={query?.value ? query.value : defaultValue ? defaultValue : query || ''}
        onChange={handleInputChange}
        placeholder={props.placeholder}
        required={props.required ? props.required : false}
        disabled={props.disabled}
      />
      {
        !props.disabled && query && (<a href="#" className="material-symbols-outlined clear-typeahead"
        onClick={
          () => {
            setQuery("");
            setSuggestions([]);
            if (props.unsetId) {
              props.unsetId();
            }
          }
        }>
        close
      </a> )
      }
      {isLoading && !props.disabled && <div className="typeahead-loading">
        <div className="spinner-border spinner-border-sm text-secondary me-1 align-text-top" role="status">
          <span className="visually-hidden">Loading...</span>
        </div> Loading...</div>}
      {noData && !props.disabled && <div className="typeahead-loading">
        <svg className="svg-1 me-1 align-text-top" viewBox="0 0 24 24" role="img" stroke="#FC1212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
          <path d="M12 10L12 13"/> <line x1="12" y1="16" x2="12" y2="16"/>
          <path d="M12.8619342,4.46528817 L21.1135176,18.4929799 C21.3935371,18.969013 21.2346366,19.5819147 20.7586035,19.8619342 C20.6049268,19.9523322 20.4298761,20 20.2515834,20 L3.74841664,20 C3.19613189,20 2.74841664,19.5522847 2.74841664,19 C2.74841664,18.8217072 2.7960844,18.6466565 2.88648243,18.4929799 L11.1380658,4.46528817 C11.4180853,3.98925504 12.030987,3.83035459 12.5070201,4.11037408 C12.6535738,4.19658212 12.7757262,4.3187345 12.8619342,4.46528817 Z"/>
        </svg>
        No Data Found
        </div>}
        {props.searchError && !props.disabled && <div className="typeahead-loading">
        <svg className="svg-1 me-1 align-text-top" viewBox="0 0 24 24" role="img" stroke="#FC1212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
          <path d="M12 10L12 13"/> <line x1="12" y1="16" x2="12" y2="16"/>
          <path d="M12.8619342,4.46528817 L21.1135176,18.4929799 C21.3935371,18.969013 21.2346366,19.5819147 20.7586035,19.8619342 C20.6049268,19.9523322 20.4298761,20 20.2515834,20 L3.74841664,20 C3.19613189,20 2.74841664,19.5522847 2.74841664,19 C2.74841664,18.8217072 2.7960844,18.6466565 2.88648243,18.4929799 L11.1380658,4.46528817 C11.4180853,3.98925504 12.030987,3.83035459 12.5070201,4.11037408 C12.6535738,4.19658212 12.7757262,4.3187345 12.8619342,4.46528817 Z"/>
        </svg>
        {props.searchError}
        </div>}
      {suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map((suggestion: any, index: any) => (
            <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
              {getHighlightedText(
                suggestion.value ? suggestion.value : suggestion,
                query
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AsyncTypeahead;
